export default __webpack_public_path__ + "static/media/portfolio-cerini-2.dba51a5c.jpg";